import React from 'react';
import ToolbarGroup from './ToolbarGroup';
import tools from '../../tools';
import { type Editor } from 'slate';
import AlignmentUtils from '../../plugins/AlignmentPlugin/AlignmentUtils';

const ToolbarAlignmentMenu = () =>
  ToolbarGroup({
    menu: {
      icon: 'fa-regular fa-align-left',
      name: 'Alignment',
      menuStyle: 'component',
      triggerComponent: ({ editor }: { editor: Editor }) => {
        switch (AlignmentUtils.currentAlignment(editor)) {
          case 'center':
            return <i className="fa-regular fa-align-center" />;
          case 'right':
            return <i className="fa-regular fa-align-right" />;
          case 'justify':
            return <i className="fa-regular fa-align-justify" />;
          default:
            return <i className="fa-regular fa-align-left" />;
        }
      },
      tools: [
        [
          tools.ToolAlignLeft,
          tools.ToolAlignCenter,
          tools.ToolAlignRight,
          tools.ToolAlignJustify,
        ],
        [tools.ToolLineHeight],
      ],
    },
  });

export default ToolbarAlignmentMenu;
